import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ChartModule } from 'angular2-highcharts';
import { EbitMarginChartOptionsProvider } from '../../providers/chart-options/ebit-margin-options';
import { HistoricImpliedIroceOptionsProvider } from '../../providers/chart-options/historic-implied-iroce';
import { HistoricSharePriceOptionsProvider } from '../../providers/chart-options/historic-share-price';
import { HistoricEbitYearThreeRatioOptionsProvider } from '../../providers/chart-options/historic-ebit-year-three-ratio';
import { HistoricEbitMarginOptionsProvider } from '../../providers/chart-options/historic-ebit-margin';
import { IndexedEbitEstimateOptionsProvider } from '../../providers/chart-options/indexed-ebit-estimate';
import { IroceChartOptionsProvider } from '../../providers/chart-options/iroce-options';
import { WciOptionsProvider } from '../../providers/chart-options/wci';
import { FaiOptionsProvider } from '../../providers/chart-options/fai';
import { MedianChartOptionsProvider } from '../../providers/chart-options/medians';
import { EbitVsSharePriceChartOptionsProvider } from '../../providers/chart-options/ebit-vs-share-price';
import { Slug } from 'ng2-slugify';

@Component({
  selector: 'wwchart',
  templateUrl: 'chart.html',
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChartComponent {
  @Input() dataSource: any = {};
  @Input() type: string = '';
  @Input() title: string = '';
  @Input() filename: string = 'chart';
  slug = new Slug('default');
  @Input() xAxesLabel: string = '';
  @Input() flexedExpectation: number;
  @Input() flexedData: object = {
    valueDrivers: {}
  };
  @Input() flexed: boolean = false;
  options: object = {
    series: []
  };

  chart: any;

  constructor(
    chartModule: ChartModule,
    public ebitMarginChartOptionsProvider: EbitMarginChartOptionsProvider,
    public historicImpliedIroceOptionsProvider: HistoricImpliedIroceOptionsProvider,
    public historicSharePriceOptionsProvider: HistoricSharePriceOptionsProvider,
    public historicEbitYearThreeRatioOptionsProvider: HistoricEbitYearThreeRatioOptionsProvider,
    public historicEbitMarginOptionsProvider: HistoricEbitMarginOptionsProvider,
    public indexedEbitEstimateOptionsProvider: IndexedEbitEstimateOptionsProvider,
    public iroceChartOptionsProvider: IroceChartOptionsProvider,
    public wciOptionsProvider: WciOptionsProvider,
    public faiOptionsProvider: FaiOptionsProvider,
    public medianChartOptionsProvider: MedianChartOptionsProvider,
    public ebitVsSharePriceChartOptionsProvider: EbitVsSharePriceChartOptionsProvider
  ) {
  }

  ngOnInit() {
    this.options = this.getChartOptions(this.dataSource, this.type, this.title, this.xAxesLabel);
  }

  ngOnChanges() {
    this.options = this.getChartOptions(this.dataSource, this.type, this.title, this.xAxesLabel);
  }
  saveInstance(chartInstance) {
    this.chart = chartInstance;
    
  }
  outputChart() {
    this.chart.exportChart({ filename: this.slug.slugify(this.filename) });
  }

  getChartOptions(dataSource, type, title, xAxesLabel) {
    if (!dataSource) {
      return;
    }
    let options = {};
    switch (type) {
      case 'ebitMargin':
        options = this.ebitMarginChartOptionsProvider.getOptions(dataSource, this.flexedExpectation, this.flexedData);
        break;
      case 'iroce':
        options = this.iroceChartOptionsProvider.getOptions(dataSource, this.flexedExpectation, this.flexedData);
        break;
      case 'fai':
        options = this.faiOptionsProvider.getOptions(dataSource, this.flexedData, this.flexed);
        break;
      case 'wci':
        options = this.wciOptionsProvider.getOptions(dataSource, this.flexedData, this.flexed);
        break;
      case 'indexedEbitEstimate':
        options = this.indexedEbitEstimateOptionsProvider.getOptions(dataSource);
        break;
      case 'historicEbitMargin':
        options = this.historicEbitMarginOptionsProvider.getOptions(dataSource);
        break;
      case 'historicImpliedEbitMarginOverY3e':
        options = this.historicEbitYearThreeRatioOptionsProvider.getOptions(dataSource);
        break;
      case 'historicSharePrice':
        options = this.historicSharePriceOptionsProvider.getOptions(dataSource);
        break;
      case 'historicImpliedIroce':
        options = this.historicImpliedIroceOptionsProvider.getOptions(dataSource);
        break;
      case 'median':
        options = this.medianChartOptionsProvider.getOptions(dataSource, title, xAxesLabel);
        break;
      case 'ebitVsSharePrice':
        options = this.ebitVsSharePriceChartOptionsProvider.getOptions(dataSource);
        break;
      default:
    }
    return options;
  }
};



// WEBPACK FOOTER //
// ./src/components/chart/chart.ts